import { IconButton } from "@mui/material";
import Arrow from "../../assets/accountDashboard/arrow.svg";

const ArrowButton = () => {
  return (
    <IconButton
      className="dashboard-icon-btn"
      sx={{
        width: "60px",
        height: "60px",
        color: "#000000ff",
        padding: "8px",
        borderRadius: "100%",
        bgcolor: "#ffffff",
        position: "relative",
        zIndex: 2,
        transition: "all 0.3s ease",

        "&:hover": {
          backgroundColor: "#ffffff",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
          "& .dashboard-arrow": {
            transform: "rotate(45deg)",
          },
        },
      }}
    >
      <img
        className="dashboard-arrow"
        src={Arrow}
        style={{
          width: "18px",
          transition: "transform 0.3s ease, filter 0.3s ease",
        }}
      />
    </IconButton>
  );
};

export default ArrowButton;